import React from 'react';
import { FingerprintIcon, SearchIcon } from 'lucide-react';
type ForensicMotifProps = {
  tone?: 'onDark' | 'onLight';
  side?: 'left' | 'right';
};
export function ForensicMotif({
  tone = 'onDark',
  side = 'right'
}: ForensicMotifProps) {
  const color = tone === 'onDark' ? 'text-gold/[0.07]' : 'text-navy/[0.06]';
  const fingerprintPos = side === 'right' ? '-right-16 top-6' : '-left-16 top-6';
  const lensPos = side === 'right' ? '-left-10 bottom-4' : '-right-10 bottom-4';
  return <div className={`pointer-events-none absolute inset-0 -z-10 overflow-hidden ${color}`} aria-hidden="true" data-id="element-213" data-mp="1vo7s1fwfch5e">
      <FingerprintIcon className={`absolute h-72 w-72 ${fingerprintPos}`} strokeWidth={0.6} data-id="element-214" data-mp="20naowd293h2a" />
      <SearchIcon className={`absolute h-48 w-48 ${lensPos}`} strokeWidth={0.6} data-id="element-215" data-mp="25essz9zklxrh" />
    </div>;
}